import React, { Fragment, useState, useEffect } from "react";
import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";
import Loader from "components/loader/loader";
import { Alert } from "react-bootstrap";
import Skeleton from "../skeleton/Skeleton";
import DropDownFilter from "components/input/dropdown/dropDownFilter";

import DashboardChart from "./DashboardChartNew";
import "react-datepicker/dist/react-datepicker.css";
import "./Dashboard.scss";
import moment from "moment";
import DashboardCard from "./DashboardCard";
import DropdownFilter from "components/input/dropdown/dropDownFilter";  

const DashboardNew = ({ allData, crmLeadData, crmDatas, originlLeads }) => {
  const [isLoading, setisLoading] = useState(false);
  const [CRMStatusList, setCRMStatusList] = useState([
    { crmStatusKey: "Success", crmStatusName: "Success" },
    { crmStatusKey: "Failure", crmStatusName: "Failure" },
  ]);
  const [gridView, setGridView] = useState(true);

  const [filterFields, setfilterFields] = useState({
    crmApprovalStatus: "Success",
    fusionApprovalStatus: "Success",
    lmsApprovalStatus: "Success",
  });

  const [crmSuccess, setCrmSuccess] = useState([]);
  const [crmFail, setCrmFail] = useState([]);
  const [crmData, setCrmData] = useState([]);
  const [fusionData, setFusionData] = useState([]);
  const [fusionSuccess, setFusionSuccess] = useState([]);
  const [fusionFail, setFusionFail] = useState([]);
  const [lmsSuccess, setLmsSuccess] = useState([]);
  const [lmsFail, setLmsFail] = useState([]);
  const [lmsData, setLmsData] = useState([]);
  const [crmLeadstTotal, setCrmLeadsTotal] = useState({ total: "" });
  const [bre, setBre] = useState({});
  const [partner, setPartner] = useState({});
  const [webhook, setWebhook] = useState([]);
  const [daLeads, setDaLeads] = useState({});
  const [partnerList, setPartnerList] = useState([]);
  const [partnerName, setPartnerName] = useState("");
  const [partnerArray, setPartnerArray] = useState([]);

  const [fromDate, setFromDate] = useState(moment().subtract(7, 'days').format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment(new Date()).format("YYYY-MM-DD"));

  useEffect(() => {
    (async () => {
      dashboardApi();
      getPartnerList()
    })();
  }, []);

  const dashboardApi = async () => {
    // setisLoading(true);
    const dataObj = {
      fromDate: fromDate,
      partnerCode: partnerName,
      toDate: toDate,
      crmSuccessOrFail: "1",
      fusionSuccessOrFail: "1",
      LMSSuccessOrFail: "1",
    };
    const res = await callWebService(callTypes.post, dataObj, Config.dashboard);
    if (res.data.status == false) {
      localStorage.clear();
    }
    const data = res?.data?.successData?.successResponse;
    if (data) {
      // setisLoading(false);
      setCrmLeadsTotal((state) => ({ ...state, total: data?.crm?.totalLead }));
      setCrmSuccess(data?.crm?.complete);
      setCrmFail(data?.crm?.faile);
      setCrmData(data?.crm?.complete);
      //setCrmFusion(data?.fusion?.success);
      const fusionSuccessObj = {
        total: data?.fusion?.total,
        success: data?.fusion?.complete,
        fail: data?.fusion?.fail,
      }
      const fusionFailObj = {
        total: data?.fusion?.total,
        // success: 0,
        fail: data?.fusion?.fail
      }
      setFusionData(fusionSuccessObj);
      setFusionSuccess(fusionSuccessObj);
      setFusionFail(fusionFailObj);

      let lmsSuccessData = data?.lms?.complete && data?.lms?.complete?.filter(f => f.api_name == 'create_customer' || f.api_name == 'create_finance' || f.api_name == 'create_mandate' || f.api_name == 'approve_mandate');

      const lmsFailData = data?.lms?.fail && data?.lms?.fail?.filter(f => f.api_name == 'create_customer' || f.api_name == 'create_finance' || f.api_name == 'create_mandate' || f.api_name == 'approve_mandate');
      // setLmsData(lmsSuccessData);
      // setLmsFail(lmsFailData);
      setBre(data?.bre);
      setPartner(data?.partners);
      setWebhook(data?.webhook);
      setDaLeads(data?.da);

      if (lmsSuccessData) {
        let successTmp = lmsSuccessData[0];
        lmsSuccessData[0] = lmsSuccessData[1];
        lmsSuccessData[1] = lmsSuccessData[2];
        lmsSuccessData[2] = lmsSuccessData[3]
        lmsSuccessData[3] = successTmp;
        setLmsData(lmsSuccessData);
        setLmsSuccess(lmsSuccessData);
      }

      if (lmsFailData) {
        let failTmp = lmsFailData[0];
        lmsFailData[0] = lmsFailData[1];
        lmsFailData[1] = lmsFailData[2];
        lmsFailData[2] = lmsFailData[3]
        lmsFailData[3] = failTmp;
        setLmsFail(lmsFailData);
      }
    } else {
      console.log('error', data)
    }
  }

  const searchDashboard = () => {
      setLmsData([]);
      setLmsFail([]);
      setLmsSuccess([]);
      setBre({});
      setPartner({});
      setWebhook([]);
      setDaLeads([])
      setFusionData([]);
      setFusionSuccess([]);
      setFusionFail([]);
      setCrmLeadsTotal((state) => ({ ...state, total: "" }));
      setCrmSuccess([]);
      setCrmFail([]);
      setCrmData([]);
      setfilterFields({
        crmApprovalStatus: "Success",
        fusionApprovalStatus: "Success",
        lmsApprovalStatus: "Success",
      });
    dashboardApi();
  }

  const handleCRMStatus = (e) => {
    const { name, value } = e.target;
    console.log('CRM DATA ONCHAGNE', name, value)
    setfilterFields((state) => ({ ...state, [name]: value }));

    if (value === "Failure" && name === "crmApprovalStatus") {
      setCrmData(crmFail);
    } else if (value === "Success" && name === "crmApprovalStatus") {
      setCrmData(crmSuccess);
    }

    if (value === "Failure" && name === "lmsApprovalStatus") {
      console.log('lms rejected', lmsFail, lmsSuccess);
      setLmsData(lmsFail);
    } else if (value === "Success" && name === "lmsApprovalStatus"){
      console.log('lms approved', lmsSuccess);
      setLmsData(lmsSuccess);
    }

    if (value === "Failure" && name === "fusionApprovalStatus") {
      console.log('fusion rejected', fusionFail, fusionSuccess);
      setFusionData(fusionFail);
    } else if (value === "Success" && name === "fusionApprovalStatus"){
      console.log('fusion approved', fusionSuccess);
      setFusionData(fusionSuccess);
    }
  };

  const handleViewLayout = () => {
    setGridView(!gridView);
  };

  const changeFromDate = (event) => {
    setFromDate(event.target.value);
  }

  const changeToDate = (event) => {
    setToDate(event.target.value);
  }

  const convertName = (data) => {
    let name = "";
    if (data === "create_lead") {
      name = "Create Lead";
    } else if (data === "get_status") {
      name = "Get Status";
    } else if (data === "update_lead") {
      name = "Update Lead";
    }
    return name;
  }

  const convertLmsName = (data) => {
    let name = "";
    if (data === "create_customer") {
      name = "Create Customer";
    } else if (data === "create_finance") {
      name = "Create Finance";
    } else if (data === "create_mandate") {
      name = "Create Mandate";
    }  else if (data === "approve_mandate") {
      name = "Approve Mandate";
    } else if (data === "disbursement") {
      name = "Disbursement";
    } else if (data === "update_finance") {
      name = "Update Finance";
    }
    return name;
  }

  const leadConditionClass = (key) => {
    let data = "";
    if (key === "total") {
      data = "l-g";
    } else if ( key === "approved") {
      data = "l-i";
    } else if (key === "rejected") {
      data = "l-d";
    } else if (key === "inprogress") {
      data = "l-in";
    }
    let fData = "card-data " + data;
    return fData;
  }

  const crmClassCondition = (value) => {
    let data = "";
    if (value.api_name === "create_lead") {
      data = "l-in";
    } else if (value.api_name === "get_status") {
      data = "l-i";
    } else if (value.api_name === "update_lead") {
      data = "l-d";
    }
    let crmData = "card-data " + data;
    return crmData;
  }

  const getPartnerList = async () => {
    setisLoading(true);
    const res = await callWebService(
      callTypes.get,
     {},
      Config.getPartnerFullList
    );

    const lanArray = [];
    const lanData = res?.data?.data?.partnerList;

    if (lanData) {
      setPartnerArray(lanData);
      lanData.filter(f =>f !== null).forEach(f => {
        let obj = {
          name: f.name,
          id: f.partner_code
        }
        lanArray.push(obj);
      })

      setPartnerList(lanArray);
      setisLoading(false)
    }
  }

  const onChangePartner = async (e) => {
    const data = e.target.value;
    setPartnerName(data);
    if (data) {
      // setLanNoCheck([]);
      // setPartnerData([]);
      // const ab = partnerArray.filter(f => f.partner_code == data);
      // const partnerId = ab[0]?.id;
      // setPartnerId(partnerId);
      // lanNoList(data);
    }
  };

  return (
    <Fragment>
      <div style={{ display: "inline-block", marginLeft: "22%" }}>
        <div style={{display: "inline-grid"}}>
        <label>From Date</label>
        <input
          type="date"
          className="search-button"
          name="fromDate"
          value={fromDate}
          onChange={changeFromDate}
          max={toDate < new Date().toISOString().split("T")[0] ? toDate : new Date().toISOString().split("T")[0] }
        /></div>
         <div style={{display: "inline-grid"}}>
          <label>To Date</label>
        <input
          type="date"
          className="search-button"
          name="toDate"
          value={toDate}
          min={fromDate}
          max={new Date().toISOString().split("T")[0]}
          onChange={changeToDate}
        />
        </div>
        &nbsp;
        <div style={{display: "inline-grid"}}>
          <label>Partner Name</label>
          <span style={{marginTop: "-11px"}}>
            <DropdownFilter
                value={partnerName}
                name="partnerName"
                optionList={partnerList}
                optIdKey="id"
                optValueKey="name"
                placeholder="Partner Name"
                onChange={(e) => onChangePartner(e)}
              />
          </span>
        </div>
        &nbsp;
        <div style={{display: "inline-grid"}}>
        <label></label>
        <button className="btn btn-primary" onClick={searchDashboard}>
          Search
        </button>
        </div>&nbsp;
        <div style={{display: "inline-grid"}}>
        <label></label>
        <button className="btn btn-warning" onClick={() => document.location.reload()}>
         
          Reset
        </button>
      </div></div>

     <div className="container-fluid" id="main">        

        {/* START LEAD MODULES */}
            <div className="mr-l">   
                <hr className="mt-3" />     
                <Alert variant="secondary title-font">
                    Lead Status
                </Alert>
            </div>
            <div className="row mb-3 ">              
              <div className="row col-xl-12 card-data-color mr-3">             
                { daLeads && Object.entries(daLeads).length > 0 ? daLeads && Object.entries(daLeads).map(([key, val]) => 
                  <DashboardCard name={key === "approved" ? "Completed" : key === "inprogress" ? "IN-PROGRESS" : key?.charAt(0).toUpperCase() + key?.slice(1)} val={val} key={key} design={leadConditionClass(key)} />
                )
                :
                <>
                {new Array(4).fill(0).map((x, idx) => <Skeleton  /> )}
                </>
                } 
              </div>
            </div>
        {/* END LEAD MODULES */}

          {/* START BRE */}
          <div className="mr-l">
                <Alert variant="secondary title-font">
                    BRE
                </Alert>
            </div>
            <div className="row mb-3 ">
              <div className="row col-xl-12">
                {bre.success ?
                <>
                <div className="col-xl-3 col-sm-6 py-2">
                  <div className="card-data l-g">
                    <h6 className="text-uppercase">Approved BRE</h6>
                    <span className="display-4sss title">{bre.success}</span>
                  </div>
                </div>
                </>
                :  <> {new Array(1).fill(0).map((x, idx) => <Skeleton  /> )}</>
                }

                {bre.fail ?
                <div className="col-xl-3 col-sm-6 py-2">
                  <div className="card-data l-d">
                    <h6 className="text-uppercase">Rejected BRE</h6>
                    <span className="display-4sss title">{bre.fail}</span>
                  </div>
                </div>
                  :  <> {new Array(1).fill(0).map((x, idx) => <Skeleton  /> )}</>
                }

              </div>
            </div>

        {/* END BRE */}
        
        {/* START TOTAL CRM */}

            <div className="mr-l">
              <Alert variant="secondary title-font">
                  CRM
              </Alert>
            </div>
            <div className="row mb-3 ">
              <div className="row col-xl-12 card-data-color mr-3">
                {crmLeadstTotal.total !== "" ? 
                <>
                <div className="col-xl-3 col-sm-6 py-2">
                    <div className="card-data l-g">
                        <h6 className="text-uppercase">Lead Count</h6>
                        <span className="display-4sss title">{crmLeadstTotal.total}</span>
                    </div>
                </div>
                </>
                : 
                <Skeleton />
              }
              </div>
            </div>

        {/* END TOTAL CRM */}

        {/* START CRM API SUCCESS OR FAILURE */}

            <div className="mr-l">
                <Alert variant="secondary title-font">{"CRM API" + " - " + filterFields.crmApprovalStatus} </Alert>
            </div>
          <div className="row mb-3 ">
            <div className="row col-xl-12 layout-r mr">
                {/* <div className="mw">
                    <DropDownFilter
                        value={filterFields.crmApprovalStatus}
                        name="crmApprovalStatus"
                        optionList={CRMStatusList}
                        optIdKey="crmStatusKey"
                        optValueKey="crmStatusName"
                        id="crmApprovalStatus"
                        placeholder="CRM Success/Failure"
                        isDashboard="yes"
                        onChange={handleCRMStatus}
                        />
                    </div> */}
            </div>
              <div className="row col-xl-12 card-data-color mr-3">
              {crmData && crmData.length > 0 ? crmData.map((value, idx) => 
                  <DashboardCard name={convertName(value.api_name)} val={value.count} key={idx} design={crmClassCondition(value)} />
                )
              :
              <> {new Array(3).fill(0).map((x, idx) => <Skeleton  /> )}</>
              }  
                
              </div>
            </div>

        {/* END CRM SUCCESS OR FAILURE */}

         {/* START CRM API FAILURE */}

         <div className="mr-l">
                <Alert variant="secondary title-font">CRM API - Failure </Alert>
            </div>
          <div className="row mb-3 ">
              <div className="row col-xl-12 card-data-color mr-3">
              {crmFail && crmFail.length > 0 ? crmFail.map((value, idx) => 
                  <DashboardCard name={convertName(value.api_name)} val={value.count} key={idx} design={crmClassCondition(value)} />
                )
              :
              <> {new Array(3).fill(0).map((x, idx) => <Skeleton  /> )}</>
              }  
                
              </div>
            </div>

        {/* END CRM FAILURE */}


         {/* START FUSION SUCCESS OR FAILURE MODULES */}

            <div className="mr-l">
                {/* <Alert variant="secondary title-font">{"Fusion API" + " - " + filterFields.fusionApprovalStatus} </Alert> */}
                <Alert variant="secondary title-font">Fusion </Alert>
            </div>
          <div className="row mb-3 ">
            {/* <div className="row col-xl-12 layout-r mr">
                <div className="mw">
                    <DropDownFilter
                        value={filterFields.fusionApprovalStatus}
                        name="fusionApprovalStatus"
                        optionList={CRMStatusList}
                        optIdKey="crmStatusKey"
                        optValueKey="crmStatusName"
                        id="fusionApprovalStatus"
                        placeholder="CRM Success/Failure"
                        isDashboard="yes"
                        onChange={handleCRMStatus}
                        />
                </div>
            </div> */}
              <div className="row col-xl-12">              
                {fusionData && Object.entries(fusionData).length > 0 ? Object.entries(fusionData).map(([key, val]) => {
                  return (
                    <div className="col-xl-3 col-sm-6 py-2" key={key}>
                          <div className={key === "total" ? "card-data l-g" : key === "success" ? "card-data l-i" : key === "fail" ? "card-data l-d": ""}>
                              <h6 className="text-uppercase">{key?.charAt(0).toUpperCase() + key?.slice(1)}</h6>
                              <span className="display-4sss title">{val}</span>
                          </div>
                      </div>
                    );
                })
                : 
                <> {new Array(3).fill(0).map((x, idx) => <Skeleton  /> )}</>                
              }  
              </div>
            </div>

        {/* END FUSION SUCCESS OR FAILURE MODULES */}

         {/* START LMS SUCCESS OR FAILURE MODULES */}

            <div className="mr-l">
                <Alert variant="secondary title-font">{"LMS" + " - " + filterFields.lmsApprovalStatus}</Alert>
            </div>
          <div className="row mb-3 ">
            {/* <div className="row col-xl-12 layout-r mr">
                <div className="mw">
                    <DropDownFilter
                        value={filterFields.lmsApprovalStatus}
                        name="lmsApprovalStatus"
                        optionList={CRMStatusList}
                        optIdKey="crmStatusKey"
                        optValueKey="crmStatusName"
                        id="lmsApprovalStatus"
                        placeholder="Lms Approval Status"
                        isDashboard="yes"
                        onChange={handleCRMStatus}
                    />
                </div>
            </div> */}
              <div className="row col-xl-12">              
              {lmsData && lmsData.length > 0 ? lmsData.map((value, idx) => {
                  return (
                    <div className="col-xl-3 col-sm-6 py-2" key={idx}>
                      <div className={value.api_name === "create_customer" ? "card-data l-g" : value.api_name === "create_finance" ? "card-data l-in" : value.api_name === "create_mandate" ? "card-data l-d" : value.api_name === "approve_mandate" ? "card-data l-i" : value.api_name === "update_finance" ? "card-data l-g" : value.api_name === "disbursement" ? "card-data l-g" : ""}>
                          <h6 className="text-uppercase">{convertLmsName(value.api_name)}</h6>
                          <span className="display-4sss title">{value.count}</span>
                      </div>
                    </div>
                    );
                })
                :
                <> {new Array(3).fill(0).map((x, idx) => <Skeleton  /> )}</>
                }  
              </div>
            </div>

        {/* END LMS SUCCESS OR FAILURE MODULES */}

        {/* START LMS SUCCESS OR FAILURE MODULES */}

        <div className="mr-l">
                <Alert variant="secondary title-font">LMS Failure</Alert>
            </div>
          <div className="row mb-3 ">
              <div className="row col-xl-12">              
              {lmsFail && lmsFail.length > 0 ? lmsFail.map((value, idx) => {
                  return (
                    <div className="col-xl-3 col-sm-6 py-2" key={idx}>
                      <div className={value.api_name === "create_customer" ? "card-data l-g" : value.api_name === "create_finance" ? "card-data l-in" : value.api_name === "create_mandate" ? "card-data l-d" : value.api_name === "approve_mandate" ? "card-data l-i" : value.api_name === "update_finance" ? "card-data l-g" : value.api_name === "disbursement" ? "card-data l-g" : ""}>
                          <h6 className="text-uppercase">{convertLmsName(value.api_name)}</h6>
                          <span className="display-4sss title">{value.count}</span>
                      </div>
                    </div>
                    );
                })
                :
                <> {new Array(3).fill(0).map((x, idx) => <Skeleton  /> )}</>
                }  
              </div>
            </div>

        {/* END LMS SUCCESS OR FAILURE MODULES */}

   

        {/* START WEBHOOK COUNT MODULES */}
            <div className="mr-l">
                <Alert variant="secondary title-font">
                    Webhook Count
                </Alert>
            </div>
            <div className="row mb-3 ">
              <div className="row col-xl-12">
              {webhook && Object.entries(webhook).length > 0 ? Object.entries(webhook).map(([key, val]) => {
                  return (
                    <div className="col-xl-3 col-sm-6 py-2" key={key}>
                          <div className={key === "total" ? "card-data l-g" : key === "complete" ? "card-data l-i" : key === "fail" ? "card-data l-d": ""}>
                              <h6 className="text-uppercase">{key?.charAt(0).toUpperCase() + key?.slice(1)}</h6>
                              <span className="display-4sss title">{val}</span>
                          </div>
                    </div>
                    );
                })
                :  <> {new Array(3).fill(0).map((x, idx) => <Skeleton  /> )}</>
              }  
              </div>
            </div>

        {/* END WEBHOOK COUNT MODULES */}

               {/* START TOTAL Partners */}

               <div className="mr-l">
                <Alert variant="secondary title-font">
                    Partners
                </Alert>
            </div>
            <div className="row mb-3 ">
              <div className="row col-xl-12">
                {Object.entries(partner).length > 0 ? Object.entries(partner).map(([key, val]) => {
                  return (
                  <div className="col-xl-3 col-sm-6 py-2">
                    <div className="card-data l-g">
                        <h6 className="text-uppercase">{ key === "totalPartnerWithDate" ? "TOTAL PARTNERS CREATED IN SELECTED PERIOD" : key?.charAt(0).toUpperCase() + key?.slice(1)}</h6>
                        <span className="display-4sss title">{val}</span>
                    </div>
                  </div>
                  );
                })
                  :  <> {new Array(1).fill(0).map((x, idx) => <Skeleton  /> )}</>
                }
              </div>
            </div>

        {/* END TOTAL Partners */}

      </div>

      <Loader isLoading={isLoading} />
    </Fragment>
  );
};

export default DashboardNew;
